import React, { useEffect, useState } from "react";
import { useLeague } from "../hooks/useLeague";
import { useAuth } from "../context/AuthContext";
import SkatingMascot from "./SkatingMascot";

const funnyMessages = [
  "Lacing up the skates...",
  "Checking if anyone remembered their jersey...",
  "Waiting for the Zamboni to finish...",
  "Counting how many guys we have this week...",
  "Turning back the clock... slowly...",
  "Stretching... very carefully...",
  "Plus de sauce sur les passes, les boys...",
  "On cherche du top cheese, bar down...",
  "Sorty les mitaines, on va danser (des dangles)...",
  "Le biscuit dans le panier, that's the goal...",
  "Beauty play... ça reste à voir...",
  "On compte les chiclets qu'il nous reste...",
  "Saucer pass parfait... dans les bancs...",
  "Wheel, snipe, celly... pis on respire un peu...",
  "Trop de sauce, pas assez de but...",
  "Le gros tank s'en vient dans le coin...",
  "On garde le biscuit au chaud...",
  "Apple pour la passe, zéro pour la finition...",
  "Forecheck solide, backcheck optionnel, paycheque obligatoire...",
];

const InitialLoadingScreen: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [showLoading, setShowLoading] = useState(true);
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);
  const { isLoading } = useLeague();
  const auth = useAuth();
  const [message] = useState(
    () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)],
  );
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  // Ensure loading screen shows for at least 2.5 seconds
  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setMinTimeElapsed(true);
    }, 2500);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setMinTimeElapsed(true);
  };

  // Hide loading screen when both conditions are met:
  // 1. Minimum time has elapsed
  // 2. Either not authenticated OR leagues have finished loading
  useEffect(() => {
    if (minTimeElapsed && (!auth.isAuthenticated() || !isLoading)) {
      setShowLoading(false);
    }
  }, [minTimeElapsed, isLoading, auth]);

  if (!showLoading) {
    return <>{children}</>;
  }

  return (
    <div
      onClick={handleClick}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(var(--bg-secondary), var(--bg-tertiary))",
        color: "var(--text-primary)",
        padding: "2rem",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <SkatingMascot width="400px" className="mb-4" />
      <h2
        style={{
          color: "var(--text-primary)",
          marginTop: "2rem",
          marginBottom: "1rem",
        }}
      >
        {message}
      </h2>
    </div>
  );
};

export default InitialLoadingScreen;
